import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltNotificationsPanelSettingsAccordionContentItemWireframe from './VeltNotificationsPanelSettingsAccordionContentItemWireframe/VeltNotificationsPanelSettingsAccordionContentItemWireframe';
var VeltNotificationsPanelSettingsAccordionContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-settings-accordion-content-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelSettingsAccordionContentWireframe.Item = VeltNotificationsPanelSettingsAccordionContentItemWireframe;
export default VeltNotificationsPanelSettingsAccordionContentWireframe;
